import { GuideContextSummary } from './guide.types';

const guidAtEnd = /_([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export const getStrategyIdFromPath = (pathname: string): string | undefined => {
  if (!pathname.toLowerCase().startsWith('/sstra/')) return undefined;
  return pathname.match(guidAtEnd)?.[1];
};

export const getGuideHeading = (context?: GuideContextSummary): string => {
  if (!context) return 'What do you want to do today?';
  if (context.work.incompleteSetupCount > 0 && context.roles.isSubscriptionOwner) {
    return "Let's get your organisation ready";
  }
  if (context.work.waitingResponseCount > 0) return 'You have work ready to complete';
  if (context.work.pendingReviewCount > 0) return 'You have updates ready to review';
  return "You're all caught up";
};

export const getGuideIntro = (context?: GuideContextSummary): string => {
  if (!context) return 'Choose a suggestion or search weavr help.';
  if (context.location.strategyName) return `Suggestions for ${context.location.strategyName} and your current work.`;
  if (context.work.waitingResponseCount > 0) {
    return `${context.work.waitingResponseCount} ${context.work.waitingResponseCount === 1 ? 'update is' : 'updates are'} waiting for you.`;
  }
  return 'Here are the most useful things you can do next.';
};
